<template>
    <div class="course-content">
        <el-scrollbar class="main-content">
            <el-breadcrumb class="genera-breadcrumb" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>课程管理</el-breadcrumb-item>
                <el-breadcrumb-item>创建课程</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="steps-wrapper">
                <div class="step-item" :class="{current: [1, 2, 3].includes(stepActive)}">
                    <div class="step-line"></div>
                    <div class="step-text">1</div>
                    <div class="step-title">课程基础信息</div>
                </div>
                <div class="step-item" :class="{current: [2,3].includes(stepActive)}">
                    <div class="step-line"></div>
                    <div class="step-text">2</div>
                    <div class="step-title">添加课程资源</div>
                </div>
                <div class="step-item" :class="{current: [3].includes(stepActive)}">
                    <div class="step-line"></div>
                    <div class="step-text">3</div>
                    <div class="step-title">完成创建</div>
                </div>
            </div>
            <courseForm v-show="stepActive === 1" @changeStep='changeStep' @saveForm="saveForm" :courseId="courseId"/>
            <courseResource v-show="stepActive === 2" @changeStep='changeStep' @saveResource="saveResource"
                            :courseId="courseId"/>
            <div class="steps-two-content" v-if="stepActive === 3">
                <img src="./../../../assets/images/admin/createSuccess.png" alt="">
                <span>创建成功</span>
                <el-button type="primary" @click="goBack">返回列表</el-button>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
    import courseForm from "./courseForm";
    import courseResource from "./courseResource";
    import {courseSave} from '@/utils/apis'

    export default {
        name: "courseCreate",
        components: {
            courseForm,
            courseResource
        },
        data() {
            return {
                stepActive: 1,
                saveData: {},
                courseId: this.$route.query.id,
                editForm: {},
                editResource: [],
            }
        },
        methods: {
            changeStep(val) {
                this.stepActive = val
            },
            saveForm(val) {
                let obj = {};
                obj.name = val.name;
                obj.classify_id = val.classify_id;
                obj.cover = val.cover;
                obj.intro = val.intro;
                obj.job_title = val.job_title;
                obj.job_level = val.job_level;
                obj.appraisal_way_time = val.appraisal_way_time;
                obj.sort = val.sort;
                obj.appraisal_outline = {};
                obj.appraisal_outline.theoretical_knowledge = [];
                obj.appraisal_outline.theoretical_knowledge = val.knowledge;
                obj.appraisal_outline.professional_skill = [];
                obj.appraisal_outline.professional_skill = val.major;
                obj.appraisal_content = val.appraisal_content;
                this.saveData = obj;
            },
            saveResource(val) {
                this.saveData.course_resources = val;
                let param = JSON.parse(JSON.stringify(this.saveData));
                param.appraisal_content = JSON.stringify(param.appraisal_content);
                param.appraisal_outline = JSON.stringify(param.appraisal_outline);
                param.course_resources = JSON.stringify(param.course_resources);
                if (this.courseId != undefined) {
                    param.id = Number(this.courseId)
                }
                courseSave(param).then((res) => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.stepActive = 3
                    } else {
                        this.$message.error(res.msg)
                    }
                }).catch((err) => {
                    console.error(err)
                })
            },
            goBack() {
                this.$router.go(-1)
            }
        }
    }
</script>

<style scoped lang="scss">
    .course-content {
        height: 100%;
        display: flex;
        flex-direction: column;

        .main-content {
            flex: 1;
            height: 100%;
        }

        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        ::v-deep .el-scrollbar__view {
            padding: 0 20px;
            height: calc(100% - 20px);
        }
    }

    .component-box {
        padding: 20px 0;
        flex: 1;
    }

    .steps-two-content {
        margin-top: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
            max-height: 240px;
            max-width: 240px;
        }

        span {
            font-size: 24px;
            line-height: 1;
            margin-top: 32px;
        }

        .el-button {
            margin: 36px 0;
        }
    }
</style>